export default "__VITE_ASSET__ClCGwQ7$__"